


























import Vue, { PropType } from "vue";
import { Federation, AssociationUtils } from "../models/Federation";

export default Vue.extend({
  name: "AssociationSelect",
  props: {
    value: {
      type: [String, Number, Array],
      required: true,
    },
    associations: {
      type: Array as PropType<Federation[]>,
      required: true,
      default: () => [],
    },
    itemValue: {
      type: String,
      required: false,
      default: "name",
    },
    label: {
      type: String,
      required: false,
      default: "Velg organisasjon",
    },
    multiple: { type: Boolean, required: false, default: false },
  },
  computed: {
    model: {
      get(): string | number | unknown[] {
        return this.value;
      },
      set(val: string | number | Array<number>) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    customFilter(item: Federation, queryText: string): boolean {
      return AssociationUtils.customFilter(item, queryText);
    },
  },
});
